declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { BillDetailsInfoController, x_BillDetailsRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, PurchaseIndentsListController, PurchaseIndentsListRequest, PurchaseOrdersListController, PurchaseOrdersListRequest, PurchaseOrderDetailsController, PurchaseOrderDetailsRequest, PurchaseOrderDetailsInfoController, SaveDoccumentStateRequest, GenericProcPostRequest, S_Methods, VendorsListController, VendorsListRequest } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../models/api_response_model';
import { SpinnerService } from '../../../services/spinner.service';
//import { billingpipe } from '../../../pipes/actors/actorIdentity.pipes';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
import { BillingPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentModeChangeModal } from './modal/paymentmodechange.modal';
import { NgbSearchPurchaseIndentsModal } from './modal/searchpurchaseindents.modal';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';



@Component({
  selector: 'povi',
  templateUrl: './povi.component.html',
  styleUrls: [
    './povi.component.scss']
  , animations: [routerTransition()]
})

export class POVIComponent implements OnInit {



  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public billdetails1: boolean = false;
  public billdetails2: boolean = false;
  public searchValue: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  SelectedFromDate: NgbDateStruct;

  CurrentPurchaseOrdersListController: PurchaseOrdersListController[];
  CurrentPurchaseOrderHeaderDetailsController: PurchaseOrdersListController;
  CurrentPurchaseOrdersListRequest: PurchaseOrdersListRequest;

  LoadOrders() {
    this.CurrentPurchaseOrdersListRequest = new PurchaseOrdersListRequest();
    this.CurrentPurchaseOrdersListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseOrdersListController();
  }
  GetPurchaseOrdersListController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrdersListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseOrdersListRequest.FromDate = new Date();
    this.CurrentPurchaseOrdersListRequest.ToDate = new Date();
    this.CurrentPurchaseOrdersListRequest.PurchaseOrderCode = 0;
    this.CurrentPurchaseOrdersListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrdersListController(this.CurrentPurchaseOrdersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseOrdersListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  LoadOrdersGeneric() {
    var getReq = new PurchaseOrdersListRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101038;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    getReq.PurchaseOrderCode = 0;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101038;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentPurchaseOrdersListController = JSON.parse(data);          
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  public TotalDiscount: number;
  CurrentPurchaseOrderDetailsController: PurchaseOrderDetailsController[];
  CurrentPurchaseOrderDetailsRequest: PurchaseOrderDetailsRequest;
  PurchaseOrderDataHeader: PurchaseOrderDetailsInfoController;

  LoadItems() {
    this.CurrentPurchaseOrderDetailsRequest = new PurchaseOrderDetailsRequest();
    this.CurrentPurchaseOrderDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseOrderDetailsController();
  }
  GetPurchaseOrderDetailsController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrderDetailsRequest.DOC = this.SelectedpatientDetails.DocID;
    this.CurrentPurchaseOrderDetailsRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrderDetailsController(this.CurrentPurchaseOrderDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPurchaseIndentItemsController = this.ApiResData.Result;
          this.PurchaseOrderDataHeader = this.ApiResData.Result;
          this.CurrentPurchaseOrderDetailsController = this.PurchaseOrderDataHeader.OrderItems;
          this.CurrentPurchaseOrderHeaderDetailsController = this.PurchaseOrderDataHeader.OrderHeader;
          this.TotalDiscount = this.CurrentPurchaseOrderDetailsController.filter(l => l.DiscountAmount)
            .reduce((sum, current) => sum + current.DiscountAmount, 0);
          //alert(this.CurrentPurchaseOrderDetailsController);
          //alert(this.CurrentPurchaseOrderHeaderDetailsController);
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  LoadItemsGeneric() {
    var getReq = new PurchaseOrderDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101039;
    getReq.DOC = this.SelectedpatientDetails.DocID;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101039;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentPurchaseOrderDetailsController = JSON.parse(data);
          //alert(this.CurrentPurchaseOrderDetailsController.length);
          //this.CurrentPurchaseOrderDetailsController = this.PurchaseOrderDataHeader.OrderItems;
          //this.CurrentPurchaseOrderHeaderDetailsController = this.PurchaseOrderDataHeader.OrderHeader;
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  constructor(private router: Router,
    public printService: PrintService,
    private modalService: NgbModal,
    private actorservice: ActorService,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private parserFormatter: NgbDateParserFormatter,
    private filter: BillingPipe,
    private tosterservice: NGXToastrService,

  ) { }

  ngOnInit() {
    //this.LoadOrders();
    this.LoadOrdersGeneric();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    
  }



  ShowList: boolean = true;

  SelectedpatientDetails: PurchaseOrdersListController;
  Selectedpatient(objCategory: any) {
    var patient: PurchaseOrdersListController = objCategory;
    if (patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = patient;
      this.CurrentPurchaseOrderHeaderDetailsController = patient;
      this.billdetails1 = true;
      //this.billdetails2 = true;
      //this.LoadItems();
      this.LoadItemsGeneric();
    }


  }
  dataChanged(newobj) {

    //this._GetPurchaseOrdersListController();
    this._LoadOrdersGeneric();
  }
  _GetPurchaseOrdersListController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrdersListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseOrdersListRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPurchaseOrdersListRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //this.CurrentPurchaseIndentsListRequest.PurchaseIndentCode = 0;
    this.CurrentPurchaseOrdersListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrdersListController(this.CurrentPurchaseOrdersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseOrdersListController = this.ApiResData.Result;
          //this.pdata = this.CurrentPurchaseIndentsListControllernew;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  _LoadOrdersGeneric() {
    var getReq = new PurchaseOrdersListRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101038;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    //getReq.PurchaseOrderCode = 0;
    getReq.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    getReq.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101038;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentPurchaseOrdersListController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  DecrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this._GetPurchaseOrdersListController();
    this._LoadOrdersGeneric();
  }
  IncrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this._GetPurchaseOrdersListController();
    this._LoadOrdersGeneric();
  }
  AddIndent() {
    this.router.navigate(['healins/poviadd']);
  }
  //AddIndent() {
  //  const modalRef = this.modalService.open(NgbSearchPurchaseIndentsModal,
  //    {
  //      centered: true,
  //      size: 'lg',
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.FromScreen = 'POVI';
  //}
  Orderedit() {
    this.router.navigate(['healins/poviedit', {
      DocIDData: this.SelectedpatientDetails.DocID
    }]);
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  header() {
    let m = document.querySelector("#header");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  summary() {
    let m = document.querySelector("#summary");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  billedit() {
    //alert("hello2");
    this.router.navigate(['healins/invoicereceipt']);
  }

  Print() {
    this.printService.printDocument2(this.SelectedpatientDetails.DocID, 0

    );
    this.printService.printDocument("purchaseorderPV",
      {
        DocIDData: this.SelectedpatientDetails.DocID, VendorCodeData: this.SelectedpatientDetails.SupplierCode
      },
    );
  }
}
